import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from "react-confirm-alert";

const MyProfileServices = ({ data, setData, setSaveEditedData }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [services, setServices] = useState(data?.serviceName || []);
  const [servicesIds, setServicesIds] = useState(data?.serviceID || []);

  useEffect(() => {
    setServices(data?.serviceName || [])
    setServicesIds(data?.serviceID || [])
  }, [data])

  const removeService = (indexToRemove) => {
    const updatedServices = services?.filter((_, index) => index !== indexToRemove);
    setServices(updatedServices);
    setData((prevData) => ({ ...prevData, "serviceName": updatedServices }));

    const updatedServicesIds = servicesIds?.filter((_, index) => index !== indexToRemove);
    setServicesIds(updatedServicesIds);
    setData((prevData) => ({ ...prevData, "serviceID": updatedServicesIds }));
    setSaveEditedData(true);
  };

  const handleDeleteService = (indexToRemove, item) => {
    confirmAlert({
      title: (
        <h4 style={{ color: "#ff0000" }}>Confirm to delete service</h4>
      ),
      message: (
        <div>
          Are you sure you want to delete <strong>{item}</strong>?
        </div>
      ),
      buttons: [
        {
          label: "Yes",
          onClick: () => removeService(indexToRemove),
          style: { background: "#ff0000" },
        },
        {
          label: "No",
        },
      ],
    });
  };


  return (
    <>
      <div className="srvcboxbrdr">
        {services?.map((item, index) => (
          <div className="brdrmaindesign" key={`itemx-${index}`}>
            {item}
            {UserProfileID?._id === data?._id &&
              <i
                className="fa-solid fa-xmark delete-icon"
                onClick={() => handleDeleteService(index, item)}
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
              ></i>
            }
          </div>
        ))}
      </div>
    </>
  );
};

export default MyProfileServices;
